module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-04.92ef9b29.png";